import { useQuery } from '@tanstack/react-query'

import type { MyBookingListItem } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { bookingKeys } from './keys.js'

export const useGetMyBookingsQuery = () =>
  useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<MyBookingListItem[]>('/me/bookings')
      // Filet si l'API n'expose pas encore `trips` (front publié avant le backend).
      return response.data.map((booking) => ({ ...booking, trips: booking.trips ?? [] }))
    },
    queryKey: bookingKeys.myBookings,
  })
